import { apiRequest } from '@common/api/utils';

function loadEligibilityData(params = {}) {
  return apiRequest('GET', `/api/v2/mentees/referral/eligibility-data`, params);
}
export default {
  loadEligibilityData,
};
